(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaGroupDeleteController',ProfessionalAreaGroupDeleteController);

    ProfessionalAreaGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfessionalAreaGroup'];

    function ProfessionalAreaGroupDeleteController($uibModalInstance, entity, ProfessionalAreaGroup) {
        var vm = this;

        vm.professionalAreaGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfessionalAreaGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
